import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import Frame from '../Wrappers/Frame';
import edit from '../../svg/edit.svg';
import { fetchWorkingHours } from '../../redux/business';
import { Row, Col } from '../Grid';
import { AnalyticsService } from '../../services/AnalyticsService';
import { Hour, Hours } from './WorkingHourTypes';

const daysShort = {
  sunday: 'SU',
  monday: 'M',
  tuesday: 'T',
  wednesday: 'W',
  thursday: 'TH',
  friday: 'F',
  saturday: 'SA',
};

const Icon = styled.div`
  width: 42px;
  height: 42px;
  border: solid 2px var(--color-white-two);
  border-radius: 21px;
  font-family: BrandonGrotesque-Regular;
  font-size: 18px;
  font-weight: 900;
  line-height: 46px;
  text-align: center;
  margin: 0 auto 10px;
  color: ${(props) => (props.visible ? '#ffffff' : '#b4a361')};
  background-color: ${(props) => (props.visible ? '#415859' : '#e8e2ce')};
`;

const Text = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 10px;
  text-align: center;
  color: #555555;
`;

interface Props {
  hours: Hours;
  getHours: Function;
  edit: Function;
  businessId: string;
}

class WorkingHours extends React.Component<Props> {
  formatHour(hour: string) {
    const time = moment.utc(hour, 'HH:mm');
    return time.toDate().getMinutes() === 0 ? time.format('h A') : time.format('h:mm A');
  }

  render() {
    if (!this.props.hours) {
      this.props.getHours(this.props.businessId);
      return null;
    }

    let saveButton = (
      <img
        alt="Save"
        src={edit}
        style={{ paddingRight: '10px', cursor: 'pointer' }}
        onClick={() => this.props.edit()}
      />
    );

    return (
      <Frame title="Business Hours" right={saveButton}>
        <Row>
          {Object.keys(daysShort).map((name: string) => (
            <Col size="1" key={name}>
              <Icon visible={this.props.hours[name].length}>{daysShort[name]}</Icon>
              <Text>
                {this.props.hours[name].map((item: Hour) => (
                  <div key={Math.random()}>
                    {this.formatHour(item.open)} - {this.formatHour(item.close)}
                  </div>
                ))}
                {!this.props.hours[name].length ? 'CLOSED' : null}
              </Text>
            </Col>
          ))}
        </Row>
      </Frame>
    );
  }
}

function mapStateToProps(state: StoreState) {
  return {
    hours: state.business.working_hours,
    businessId: state.business.business_id,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    edit: () => {
      dispatch(push('/profile/hours'));
      AnalyticsService.track('Edit Business hours', {});
    },
    getHours: (businessId) => dispatch(fetchWorkingHours(businessId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkingHours);
